import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop({ container }: { container?: React.RefObject<HTMLDivElement | null> | null }) {
  const { pathname } = useLocation()

  useEffect(() => {
    if (container?.current) {
      if (typeof container.current.scrollTo === "function") {
        container.current.scrollTo({ top: 0, behavior: "instant" })
      }
    } else if (typeof window.scrollTo === "function") {
      window.scrollTo({ top: 0, behavior: "instant" })
    }
  }, [pathname, container])

  return null
}
